import { render, staticRenderFns } from "./TerminManager.vue?vue&type=template&id=7c587f43&scoped=true"
import script from "./TerminManager.vue?vue&type=script&lang=js"
export * from "./TerminManager.vue?vue&type=script&lang=js"
import style0 from "./TerminManager.vue?vue&type=style&index=0&id=7c587f43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c587f43",
  null
  
)

export default component.exports